<template>
  <div>
    <v-card class="px-3 pt-1 pb-3">
      <div class="text-xs-right">
        <v-btn fab flat @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div>
        <template v-if="memberDetail">
          <v-card class="bg-profile-card pa-3" max-width="1000px">
            <v-layout wrap>
              <v-flex xs3 class="align-center" style="display: flex">
                <v-avatar :tile="false" size="128px" color="grey lighten-4">
                  <img :src="memberDetail.profile_pic" alt="avatar" />
                </v-avatar>
              </v-flex>
              <v-flex xs9>
                <div class="primary--text">{{ memberDetail.full_name }}</div>
                <div class="mt-3">
                  <span class="font-weight-bold"> ประเภทบัญชี :</span>
                  {{ memberDetail.member_type === 'buyer' ? 'ผู้เช่าซื้อ' : 'นักลงทุน' }}
                </div>
                <div>
                  <span class="font-weight-bold">เบอร์โทรศัพท์ :</span>
                  {{ memberDetail.identity_card_no || '-' }}
                </div>
                <div>
                  <span class="font-weight-bold">โครงการ / หมู่บ้าน :</span>
                  {{ memberDetail.project || '-' }}
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </template>
      </div>
      <div v-if="memberDetail">
        <v-data-table
          :headers="headers"
          :items="assetList"
          class="elevation-1 mt-3"
          :pagination.sync="pagination"
        >
          <template #items="props">
            <tr>
              <td>{{ props.item.asset_no || '-' }}</td>
              <td>{{ props.item.asset_name || '-' }}</td>
              <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY hh:mm A') }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.status" class="green--text">เปิด</span>
                <span v-else class="red--text">ปิด</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      memberDetail: null,
      pagination: { sortBy: 'none', descending: false, rowsPerPage: 10 },
      headers: [
        { text: 'รหัสทรัพย์', value: 'asset_no', sortable: false },
        { text: 'ชื่อทรัพย์', value: 'asset_name', sortable: false },
        { text: 'วันที่เพิ่ม', value: 'timestamp', sortable: false },
        { text: 'การแจ้งเตือนค่างวด', value: 'status', sortable: false, align: 'center' }
      ]
    }
  },
  computed: {
    assetList() {
      return this.memberDetail.assets || []
    }
  },
  mounted() {
    if (this.value) {
      this.memberDetail = this.value
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/MemberDetailDialog.vue